import { HeroSection } from "@/components/home/HeroSection";
import { WhatWeBuildSection } from "@/components/home/WhatWeBuildSection";
import { TrustSection } from "@/components/home/TrustSection";
import { OpenSourceSection } from "@/components/home/OpenSourceSection";
import { ReportSection } from "@/components/home/ReportSection";
import { RecentBlogSection } from "@/components/home/RecentBlogSection";
import { CTASection } from "@/components/home/CTASection";
import { WebSiteJsonLd } from "@/components/seo/JsonLd";

const Index = () => {
  return (
    <>
      <WebSiteJsonLd />
      <HeroSection />
      <WhatWeBuildSection />
      <TrustSection />
      <OpenSourceSection />
      <ReportSection />
      <RecentBlogSection />
      <CTASection />
    </>
  );
};

export default Index;
